import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const CustomReportTemplateIcon = (props) => {
  const { getThemeColor, themeName } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.5 0C12.8807 0 14 1.11929 14 2.5V11.5C14 12.8807 12.8807 14 11.5 14H2.5C1.11929 14 0 12.8807 0 11.5V2.5C0 1.11929 1.11929 0 2.5 0H11.5ZM3.5 3C3.25454 3 3.05039 3.17688 3.00806 3.41012L3 3.5V10.5L3.00806 10.5899C3.05039 10.8231 3.25454 11 3.5 11C3.74546 11 3.94961 10.8231 3.99194 10.5899L4 10.5V3.5L3.99194 3.41012C3.94961 3.17688 3.74546 3 3.5 3Z"
        // fill={props.active ? "white" : "#7B7B7B"}
        fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default CustomReportTemplateIcon;
